import axios from "axios";
import { getAuth } from "firebase/auth";

const API_BASE_URL = "https://europe-west3-hyper-e122e.cloudfunctions.net";

export default class FollowService {
  /**
   * 🔁 Тоггл подписки на компанию (подписка или отписка)
   * @param {string} companyId - ID компании
   * @returns {Promise<"subscribed" | "unsubscribed" | null>} - статус после действия
   */
  static async toggleFollowCompany(companyId) {
    try {
      const auth = getAuth();
      const user = auth.currentUser;
      if (!user) {
        throw new Error("Пользователь не авторизован");
      }

      const token = await user.getIdToken();

      const response = await axios.post(
        `${API_BASE_URL}/toggle_follow_company`,
        { company_id: companyId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const status = response.data?.status;

      if (status === "subscribed") {
        console.log("✅ Подписка на компанию выполнена");
        return "subscribed";
      }

      if (status === "unsubscribed") {
        console.log("✅ Отписка от компании выполнена");
        return "unsubscribed";
      }

      console.warn("⚠️ Неожиданный ответ toggle_follow_company:", response.data);
      return null;
    } catch (error) {
      console.error(
        "❌ Ошибка toggle_follow_company:",
        error.response?.data || error.message
      );
      return null;
    }
  }
}